/**
 *
 * @param {String} str
 * @param {String[]} synonyms
 * @returns {Boolean}
 */
function checkSynonyms(str: string, synonyms: string[]): boolean {
  for (let i = 0; i < synonyms.length; i += 1) {
    if (str === synonyms[i]) {
      return true
    }
  }
  return false
}

/**
 * check whether the input string match with Table synonyms
 * @param {String} str - string to compare with synonyms
 * @returns {Boolean}
 */
export function CheckIsTable(str: string): boolean {
  return checkSynonyms(str, ['DESK', 'DESKS', 'TABLE', 'TABLES'])
}

/**
 * check whether the input string match with Chair synonyms
 * @param {String} str - string to compare with synonyms
 * @returns {Boolean}
 */
export function CheckIsChair(str: string): boolean {
  return checkSynonyms(str, ['SEAT', 'SEATS', 'CHAIR', 'CHAIRS'])
}

/**
 * check whether the input string match with HotDesk synonyms
 * @param {String} str - string to compare with synonyms
 * @returns {Boolean}
 */
export function CheckIsHotDesk(str: string): boolean {
  return checkSynonyms(str, [
    'HOT DESK',
    'HOT DESKS',
    'PRIVATE HOT DESK AREA',
    'PRIVATE HOT DESKS AREA',
    'HOT DESK AREA',
    'HOT DESKS AREA',
  ])
}

/**
 * check whether the input string match with DedicatedDesk synonyms
 * @param {String} str - string to compare with synonyms
 * @returns {Boolean}
 */
export function CheckIsDedicatedDesk(str: string): boolean {
  return checkSynonyms(str, [
    'DEDICATED DESK',
    'DEDICATED DESKS',
    'SHARED OFFICE DESK',
    'SHARED OFFICE DESKS',
  ])
}
